module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-standside-1750.abccf55f.svg";